export type FormateurDiplome = {
  libelle: string;
  etablissement?: string;
  annee?: string;
};

export type FormateurDisponibilite = {
  jour: string;
  creneau?: string;
  commentaire?: string;
};

export type FormateurReferencement = {
  id?: string;
  nom: string;
  fonction?: string;
  telephone?: string;
  email?: string;
  statutValidation?: 'EN_ATTENTE' | 'VALIDE' | 'REJETE';
  commentaireAdmin?: string;
  dateValidation?: string | null;
};

const JOURS = ['LUNDI', 'MARDI', 'MERCREDI', 'JEUDI', 'VENDREDI', 'SAMEDI', 'DIMANCHE'] as const;

export const JOURS_SEMAINE = JOURS;

/** Créneaux officiels — alignés sur les vacations du planning (seed SI-SEP). */
export const FORMATEUR_DISPONIBILITE_CRENEAU_OPTIONS = [
  '08h00 – 10h00',
  '10h00 – 12h00',
  '12h00 – 14h00',
  '14h00 – 16h00',
  '16h00 – 18h00',
  '18h00 – 20h00',
] as const;

export type FormateurDisponibiliteCreneauOption =
  (typeof FORMATEUR_DISPONIBILITE_CRENEAU_OPTIONS)[number];

export function resolveFormateurDisponibiliteCreneauOptions(current?: string | null): string[] {
  const trimmed = current?.trim() ?? '';
  if (
    trimmed &&
    !FORMATEUR_DISPONIBILITE_CRENEAU_OPTIONS.includes(trimmed as FormateurDisponibiliteCreneauOption)
  ) {
    return [trimmed, ...FORMATEUR_DISPONIBILITE_CRENEAU_OPTIONS];
  }
  return [...FORMATEUR_DISPONIBILITE_CRENEAU_OPTIONS];
}

export function parseDiplomes(raw: unknown): FormateurDiplome[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((row) => {
      const o = row as Record<string, unknown>;
      const libelle = String(o.libelle ?? '').trim();
      if (!libelle) return null;
      return {
        libelle,
        etablissement: o.etablissement != null ? String(o.etablissement).trim() : undefined,
        annee: o.annee != null ? String(o.annee).trim() : undefined,
      };
    })
    .filter(Boolean) as FormateurDiplome[];
}

export function parseDisponibilites(raw: unknown): FormateurDisponibilite[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((row) => {
      const o = row as Record<string, unknown>;
      const jour = String(o.jour ?? '').trim().toUpperCase();
      if (!jour) return null;
      return {
        jour,
        creneau: o.creneau != null ? String(o.creneau).trim() : undefined,
        commentaire: o.commentaire != null ? String(o.commentaire).trim() : undefined,
      };
    })
    .filter(Boolean) as FormateurDisponibilite[];
}

export function parseReferencements(raw: unknown): FormateurReferencement[] {
  if (!Array.isArray(raw)) return [];
  return raw
    .map((row) => {
      const o = row as Record<string, unknown>;
      const nom = String(o.nom ?? '').trim();
      if (!nom) return null;
      return {
        id: o.id != null ? String(o.id).trim() : undefined,
        nom,
        fonction: o.fonction != null ? String(o.fonction).trim() : undefined,
        telephone: o.telephone != null ? String(o.telephone).trim() : undefined,
        email: o.email != null ? String(o.email).trim() : undefined,
        statutValidation:
          o.statutValidation === 'VALIDE' || o.statutValidation === 'REJETE'
            ? (o.statutValidation as 'VALIDE' | 'REJETE')
            : 'EN_ATTENTE',
        commentaireAdmin: o.commentaireAdmin != null ? String(o.commentaireAdmin).trim() : undefined,
        dateValidation: o.dateValidation != null ? String(o.dateValidation) : null,
      };
    })
    .filter(Boolean) as FormateurReferencement[];
}
